import React, { useState, useEffect } from "react";
import { useAppContext } from "../../context/appContext";

const PaymentContainer = () => {
    const { paymentScreen, togglePayment, basket, user, createPayment, updateStatus } =
        useAppContext();

    const [totalPay, setTotalPay] = useState();
    const [tendered, setTendered] = useState(0);
    const [cashPayment, setCashPayment] = useState(0);
    const [cardPayment, setCardPayment] = useState(0);

    useEffect(() => {
        if (basket.TotalPrice > 1) {
            setTotalPay(basket.TotalPrice);
        }
    }, [basket.TotalPrice]);

    const cashHandler = () => {
        if (totalPay - tendered === 0) {
            // Fully paid
            setCashPayment(parseFloat(cashPayment) + parseFloat(tendered));
            setTotalPay(0);
            processPayment();
        } else if (totalPay - tendered < 0) {
            // Overpaid
            let change = parseFloat(tendered) - totalPay;
            let currCash = parseFloat(tendered) - change;

            setCashPayment(parseFloat(cashPayment) + parseFloat(currCash));
            setTotalPay(0);
            processPayment();
        } else {
            // Paid less than total
            setCashPayment(parseFloat(cashPayment) + parseFloat(tendered));
            setTotalPay(parseFloat(totalPay) - parseFloat(tendered));
        }
        setTendered(0);
    };
    const cardHandler = () => {
        if (totalPay - tendered === 0) {
            // Fully paid
            setCardPayment(parseFloat(cardPayment) + parseFloat(tendered));
            setTotalPay(0);
            processPayment();
        } else if (totalPay - tendered < 0) {
            // Overpaid
            let change = parseFloat(tendered) - totalPay;
            let currCard = parseFloat(tendered) - change;

            setCardPayment(parseFloat(cardPayment) + parseFloat(currCard));
            setTotalPay(0);
            processPayment();
        } else {
            // Paid less than total
            setCardPayment(parseFloat(cardPayment) + parseFloat(tendered));
            setTotalPay(parseFloat(totalPay) - parseFloat(tendered));
        }
        setTendered(0);
    };

    const processPayment = async () => {
        //Create payment
        await createPayment({
            TableId: basket.tableId,
            processedBy: user._id,
            Amount: { Cash: cashPayment, Card: cardPayment },
        });
        //Update table status
        await updateStatus(basket.tableId, basket.tableNum);

        //Close payment screen
        await togglePayment();
    };

    const closePayment = () => {
        togglePayment();
    };

    if (paymentScreen) {
        return (
            <div
                className={
                    "z-1 absolute left-0 top-0 flex h-full w-full max-w-[1096px] items-center justify-center bg-main-600"
                }
            >
                <div
                    onClick={closePayment}
                    className='absolute top-5 left-5 z-[500] cursor-pointer text-4xl '
                >
                    X
                </div>
                <div className='flex w-full max-w-[500px] flex-col items-center justify-center '>
                    <div className='ppy-6 flex w-full items-center justify-center rounded-md bg-slate-50 py-6 text-black'>
                        <div className='flex flex-1 flex-col  justify-center px-6'>
                            <p>Total to pay</p>
                            <span className='font-mono text-5xl'> {totalPay}</span>
                        </div>
                        <div className='flex flex-1 flex-col  justify-center px-6'>
                            <p>Amount tendered</p>
                            <input
                                value={tendered}
                                onInput={(e) => setTendered(parseFloat(e.target.value))}
                                placeholder='00.00'
                                className='max-w-[200px] font-mono text-5xl'
                                type='number'
                                step='0.01'
                            />
                        </div>
                    </div>
                    <div className='mt-8 flex gap-x-10 text-2xl'>
                        <div
                            onClick={cashHandler}
                            className='cursor-pointer rounded-md bg-main-800 px-8 py-2 text-white'
                        >
                            Cash
                        </div>
                        <div
                            onClick={cardHandler}
                            className='cursor-pointer rounded-md bg-main-800 px-8 py-2 text-white'
                        >
                            Bank Card
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default PaymentContainer;
